<script>
    let navDatas = [
        {id: 1, subject: '프로젝트', link: '#'},
        {id: 2, subject: '인기영상', link: '#'},
        {id: 3, subject: '커뮤니티', link: '#'},
    ]
</script>

<header class="header" id="#top">
    <h1 class="logo"><a href="#top"><img src="/images/header-logo.png" alt="고!팬딩" /></a></h1>
    <nav class="nav">
        {#each navDatas as navData (navData.id)}
            <a class="nav__item" href={navData.link}>{navData.subject}</a>
        {/each}
    </nav>
</header>

<style>
    .header {
        position: sticky;
        left: 0; 
        top: 0;
        width: 100%;
        z-index: 1000;
    }
    .logo {
        text-align: center;
        padding: 10px 0;
        background: #fff;
    }
    .logo img {
        width: 250px;
    }
    .nav {
        display: flex;
        background: #333;
    }
    .nav__item {
        flex: 1;
        padding: 10px 0;
        color: #fff;
        text-align: center;
        font-weight: 600;
    }
</style>